import {stringCompare} from "../utils";
import {ref} from "vue";

const siteInspectionRoots = ['locations', 'circuits', 'circuitComponents', 'labels', 'examinations', 'notes', 'timeTracks'];
const editableSiteInspectionRoots = siteInspectionRoots.filter(e => e !== 'timeTracks');

const indexedRoots = [
    {name: 'locations', idx: 'locationIndex'},
    {name: 'circuits', idx: 'circuitIndex'}
];

function siteInspectionCreate() {
    return ref({
        testingIds: [],
        locations: [],
        circuits: [],
        labels: [],
        circuitComponents: [],
        examinations: [],
        timeTracks: [],
        currentCircuitUuid: null,
        currentLocationUuid: null,
        tester: '',
        notes: [],
    }).value;
}

function siteInspectionGenerateName(siteInspection, testings) {
    const getName = (testing) => {
        const foundTesting = testings.find(searchingTesting => searchingTesting.__identity === testing.__identity);
        return foundTesting !== undefined ? `${foundTesting.operationNumber} (${foundTesting?.testingType?.name})` : 'Unbekannt';
    };
    return siteInspection.siteInspection?.testings.map(getName).sort(stringCompare).join(', ') ?? 'unbekannt';
}

const filterSiteInspectionElements = (siteInspection, predicate, maintainIndexes) => {
    const data = {};
    for (const root of siteInspectionRoots) {
        if (siteInspection[root] === undefined) {
            continue;
        }
        data[root] = siteInspection[root].filter(predicate);
    }
    if (! maintainIndexes) {
        return data;
    }
    indexedRoots.forEach(indexedRoot => {
        const {name: indexedRootName, idx: indexName} = indexedRoot;
        if (data[indexedRootName].length < siteInspection[indexedRootName].length) {
            data[indexedRootName].forEach((indexedElement, newElementIndex) => {
                siteInspectionRoots.filter(root => root !== indexedRootName).forEach(root => {
                    data[root].forEach(elementWithIndexRelation => {
                        if (!elementWithIndexRelation[indexName]) {
                            return; //those have no relation index of the current relation
                        }
                        // TODO: Do we really need this?
                        // if (!data[indexedRootName].includes(siteInspection[indexedRootName][elementWithIndexRelation[indexName]])) {
                        //     throw new Error('Could not find need element in filtered SiteInspection');
                        // }
                        if (siteInspection[indexedRootName][elementWithIndexRelation[indexName]] === indexedElement) {
                            elementWithIndexRelation[indexName] = newElementIndex;
                        }
                    });
                });
            });
        }
    });
    return data;
};

const mapReduceNavigationElements = (siteInspection, map) => {
    const data = {};
    for (const root of siteInspectionRoots) {
        data[root] = siteInspection[root].reduce(map, {});
    }
    return data;
};

const forEachSiteInspectionElement = (siteInspection, elementCallback) => {
    if (siteInspection === undefined) {
        return;
    }
    siteInspectionRoots.forEach(root => {
        if ((siteInspection[root] instanceof Array)) {
            siteInspection[root].forEach(value => elementCallback(value, root));
        }
    })
};

const siteInspectionHasBeenSynced = (siteInspection) => {
    for (const root of siteInspectionRoots) {
        if (!(siteInspection[root] instanceof Array)) {
            continue;
        }
        for (const element of siteInspection[root]) {
            if (element.synced) {
                return true;
            }
        }
    }
    return false;
};

const predicates = {
    seen: (item) => item.dirty === false,
    shouldSynchronized: (item) => item.dirty !== true || item.synced?.seenBy.length > 0,
    shouldBeDisplayedInSynchronization: (item) => true,
    unseen: (item) => item.dirty === true,
    created: (item) => item.dirty === undefined || item.dirty === null,
    omitDirtyButSynced: (item) => !(item.dirty && item.synced),
    all: () => true
};

export {
    siteInspectionCreate,
    siteInspectionGenerateName,
    filterSiteInspectionElements,
    mapReduceNavigationElements,
    predicates,
    siteInspectionRoots,
    editableSiteInspectionRoots,
    siteInspectionHasBeenSynced,
    forEachSiteInspectionElement
}
